import React from 'react';
import { TableRow } from '@mui/material';
import { useParams } from 'react-router-dom';

import { EsgDmaSubSubTopicOutSchema } from '../../../types';
import { useDmaImpacts, useEsgDmas } from '../../../hooks';
import CollapsableButtonCell from 'src/Esg/Dmav2/components/CollapseButtonCell';
import ImpactRow from './ImpactRow';
import AddImpactRow from './AddImpactRow';
import { useEsgReports } from 'src/Esg/hooks';
import DeleteCustomSubSubtopicCell from '../../../components/DeleteCustomSubSubtopicCell';

interface Props {
  subsubtopic: EsgDmaSubSubTopicOutSchema;
}

export default function SubSubTopicRow(props: Props) {
  const { subsubtopic } = props;
  const { reportId } = useParams();
  const { _instance: esgReport } = useEsgReports({ id: Number(reportId) });
  const { _instance: dma } = useEsgDmas({ id: esgReport?.esg_dma_id });
  const { _data: impacts } = useDmaImpacts({ esg_dma_id: dma?.id });
  const [collapsed, setCollapsed] = React.useState(false);
  const data = impacts.filter(
    (i) => i.esg_dma_sub_sub_topic_id === subsubtopic.id
  );
  return (
    <>
      <TableRow>
        <CollapsableButtonCell
          colSpan={7}
          text={subsubtopic.description}
          collapsed={collapsed}
          setCollapsed={setCollapsed}
          sx={{ paddingLeft: '32px' }}
        />
        <DeleteCustomSubSubtopicCell subsubtopic={subsubtopic} />
      </TableRow>

      {!collapsed &&
        data.map((impact) => <ImpactRow key={impact.id} impact={impact} />)}

      {!collapsed && <AddImpactRow subSubTopicId={subsubtopic.id} />}
    </>
  );
}
